import { InfoBar } from '@2n/design-system';
import * as React from 'react';

export interface IInfoBarData {
  children: React.ReactNode;
}

export function FilledInfoBar(data: IInfoBarData) {
  return (
    <InfoBar
      variant="filled"
      type="info"
      sx={{
        backgroundColor: 'subscription.backgroundLight',
        color: 'secondary.main',
        my: 2,
      }}
    >
      {data.children}
    </InfoBar>
  );
}
